/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Legajox_Absence_Detail_ErrorInputs */

const es_tools_legajox_absence_detail_error = /** @type {(inputs: Tools_Legajox_Absence_Detail_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al consultar detalle de ausencia de Legajox`)
};

const en_tools_legajox_absence_detail_error = /** @type {(inputs: Tools_Legajox_Absence_Detail_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error querying Legajox absence detail`)
};

/**
* | output |
* | --- |
* | "Error querying Legajox absence detail" |
*
* @param {Tools_Legajox_Absence_Detail_ErrorInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_legajox_absence_detail_error = /** @type {((inputs?: Tools_Legajox_Absence_Detail_ErrorInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Legajox_Absence_Detail_ErrorInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_legajox_absence_detail_error(inputs)
	return en_tools_legajox_absence_detail_error(inputs)
});
export { tools_legajox_absence_detail_error as "tools.legajox.absence_detail_error" }